import { isValid, parseISO } from 'date-fns';

/**
 * Parses the `dates` query parameter into dates for the search input.
 * Empty or unparsable values (e.g. `?dates=`) are dropped, because formatting
 * an Invalid Date throws `RangeError: Invalid time value` during render.
 */
const parseDatesQuery = (dates: string | string[] | undefined): Date[] => {
  const values = typeof dates === 'string' ? [dates] : dates ?? [];
  return values
    .filter(Boolean)
    .map((date) => parseISO(date))
    .filter(isValid);
};

export default parseDatesQuery;
